import React from 'react';
import { useAuth } from '../../hooks/auth';

import CountUp from 'react-countup';
import { BarProgressInfo, BoxContainer, LevelProgressBadge, LevelProgressNumber, LevelProgressTitle, ProgressBarContent, ProgressStat, ProgressStatInfo } from './styles';
import ProgressBar from '../ProgressBar';
import { useTheme } from '../../hooks/theme';


const LevelProgressBox: React.FC = () => {
  const { user } = useAuth();
  const { theme } = useTheme()

  return (
    <BoxContainer>
      <LevelProgressBadge>
        <LevelProgressTitle>Level</LevelProgressTitle>
        <LevelProgressNumber>{user.level}</LevelProgressNumber>
      </LevelProgressBadge>

      <ProgressStat>
        <BarProgressInfo>
          <span><CountUp end={(100 - user.current_exp) || 0} duration={5} prefix="+" suffix=" EXP" /></span><span>Para alcançar o próximo nível</span>
        </BarProgressInfo>
        <ProgressStatInfo>{(user.exp || 0).toLocaleString(['pt-BR'])} <br /> <span>Pontos acumulados</span></ProgressStatInfo>
        <ProgressBarContent>
          {user.id && (
            <ProgressBar
              width="100%"
              height="6px"
              percentage={Number(user?.exp % 100)}
              bgColor={theme === 'dark' ? '#bed0de35' : '#bed0de50'}
              barColor={theme === 'dark' ? '#00ee98' : '#00ee98'}
              rectBorderRadius='12px'
              trackBorderColor="transparent"
              style={{ marginTop: '8px', }}
            />
          )}
        </ProgressBarContent>
      </ProgressStat>
    </BoxContainer>
  );
}

export default LevelProgressBox;
